
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.394 1.195a.641.641 0 01-.018.897L2.75 17.323a.618.618 0 01-.884-.018.642.642 0 01.018-.897L17.51 1.177a.618.618 0 01.884.018zm-2.442 5.041a.619.619 0 01.873-.139 17.868 17.868 0 012.655 2.418l.003.003a2.06 2.06 0 010 2.733l-.002.002c-2.183 2.44-5.804 5.037-9.485 4.978a8.82 8.82 0 01-2.713-.409.636.636 0 01-.411-.794.623.623 0 01.782-.418 7.588 7.588 0 002.34.351h.015c3.149.054 6.454-2.223 8.546-4.56a.78.78 0 000-1.032 16.6 16.6 0 00-2.467-2.247.641.641 0 01-.136-.886zM10 3.539a8.459 8.459 0 012.16.257.635.635 0 01.456.77.625.625 0 01-.758.462 7.226 7.226 0 00-1.852-.22h-.018C6.894 4.756 3.58 6.982 1.445 9.367a.78.78 0 000 1.032c.639.71 1.337 1.365 2.086 1.955a.641.641 0 01.11.89.619.619 0 01-.877.113A18.064 18.064 0 01.52 11.253l-.003-.003A2.06 2.06 0 010 9.883c0-.505.184-.991.517-1.366l.002-.003C2.749 6.023 6.379 3.482 10 3.54z","fill":"#5C6970"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.998 7.346a2.466 2.466 0 00-1.767.744 2.571 2.571 0 00-.732 1.795.63.63 0 01-.625.635.63.63 0 01-.625-.635 3.847 3.847 0 011.098-2.693 3.746 3.746 0 011.217-.825 3.7 3.7 0 011.435-.29.63.63 0 01.625.635.63.63 0 01-.626.634zm3.125 1.903a.63.63 0 01.626.634c0 .5-.097.996-.286 1.458a3.813 3.813 0 01-.812 1.236 3.747 3.747 0 01-1.217.825 3.7 3.7 0 01-1.435.29.63.63 0 01-.625-.634c0-.35.28-.635.625-.635a2.467 2.467 0 001.768-.744 2.574 2.574 0 00.732-1.795c0-.35.28-.635.625-.635z","fill":"#5C6970"}})])
          )
        }
      }
    